/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Component for New Eligibility Request Button
 */
import { Button, ButtonProps } from 'antd';
import { Plus } from '@icon-park/react';
import { Link } from 'react-router-dom';

import { getEligibilityNewRequestPath } from 'utils/router';

/**
 * New Eligibility Request
 */
const NewEligibilityRequest: React.FC<ButtonProps> = (props) => {
	return (
		<Link to={getEligibilityNewRequestPath()}>
			<Button type='primary' {...props}>
				<Plus />
				{'New Request'}
			</Button>
		</Link>
	);
};

export default NewEligibilityRequest;
